<template>
  <div
    class="w-full px-5 py-6 border-1 border-solid border-grey-200 rounded-lg bg-white"
  >
    <p class="u-body text-heading font-bold mb-2">Unsure?</p>
    <p class="u-body mb-4">
      Enter a postcode to find your nearest {{ postcodeSearchType }}:
    </p>

    <div class="mb-7">
      <NearbyInput
        :type="type"
        placeholder="eg: 3205"
        :communities="communities"
        :nearbyRedirectUrl="nearbyRedirectUrl"
      />
    </div>

    <!-- <template v-if="!forMobile">
      <p class="u-body text-heading font-bold mb-3">
        Ready to start your biggest chapter?
      </p>

      <a
        class="bg-white inline-flex relative flex-nowrap items-center group focus:outline-none rounded-lg h-12 px-6 py-2 border border-solid border-primary transition duration-200 ease-in-out mb-7"
        :href="`${enquireUrl}?bookTour=true`"
      >
        <span
          class="absolute -inset-1.5 opacity-0 group-focus:opacity-100 border-2 border-grey-900 border-solid rounded-lg transition-opacity duration-200 ease-in-out pointer-events-none"
        ></span>
        <span
          class="u-body-md font-bold border-b-2 border-solid border-transparent group-hover:border-current transition-colors duration-200 ease-in-out text-grey-900"
        >
          Book a tour
        </span>
      </a>
    </template> -->

    <ul v-if="navItems.length">
      <li
        v-for="(navItem, index) in navItems"
        :key="navItem.id"
        :class="{
          'mt-2': index !== 0,
        }"
      >
        <a
          :href="navItem.url"
          :target="navItem.newWindow ? '_blank' : '_self'"
          :class="[
            'group relative focus:outline-none ',
            navItem.headerNavType
              ? 'inline-flex flex-nowrap text-heading font-semibold items-center u-body-md rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid border-primary hover:shadow-button-secondary transition duration-200 ease-in-out'
              : 'inline-block text-body u-body-lg',
            navItem.classes,
            {
              'cursor-default': !navItem.url,
            },
          ]"
        >
          <span
            :class="[
              'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
            ]"
          ></span>
          <span
            :class="[
              'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
            ]"
          >
            {{ navItem.title }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import NearbyInput from '../../NearbyInput';
import { COMMUNITY_TYPE, HOMES_TYPE } from '../../../configs/type';

export default {
  components: {
    NearbyInput,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return [COMMUNITY_TYPE, HOMES_TYPE].includes(value);
      },
    },
    navItems: {
      type: Array,
      required: true,
    },
    communities: {
      type: Array,
      required: true,
    },
    nearbyRedirectUrl: {
      type: String,
      required: true,
    },
    enquireUrl: {
      type: String,
      required: true,
    },
    forMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    postcodeSearchType() {
      let text = '';
      switch (this.type) {
        case COMMUNITY_TYPE:
          text = 'community';
          break;
        case HOMES_TYPE:
          text = 'home';
          break;
      }
      return text;
    },
  },
};
</script>
